<template>
  <div class="login-code">
    <div class="tel-txt" v-if="activityInfo.employeeId && isLoginCode">Tel：+{{ activityInfo.countryCode }} {{ activityInfo.newPhone }}</div>
    <div class="form-item" v-if="!activityInfo.employeeId">
      <label class="label"><span class="required">*</span> Phone</label>
      <div class="phone-wrapper">
        <XuCountryCode class="country-code-field" v-model="formData.countryCode" />
        <van-field
          v-model="formData.phone"
          maxlength="15"
          type="digit"
          clickable
          class="custom-field phone-field"
          :border="false"
        />
      </div>
    </div>
    <van-field v-if="!isLoginCode" v-model="formData.authorizationCode" maxlength="4" class="anth-code" :border="false" placeholder="Authorization Code" />
    <div class="form-content" v-if="isLoginCode">
      <!-- SMS -->
      <div class="form-item sms-item">
        <div class="input-wrapper">
          <van-field v-model="formData.code" class="custom-field" placeholder="SMS" :border="false" />
        </div>
        <span class="get-code-btn" :class="{ 'disabled': countdown > 0 }" @click="handleGetCode">
          {{ countdown > 0 ? `${countdown}s` : 'Get Verification Code' }}
        </span>
      </div>

      <!-- Agreement -->
      <!-- <div class="agreement-item">
        <van-checkbox v-model="formData.agreed" shape="round" icon-size="16px" checked-color="#ee541b">
          <div class="agreement-text">
            I agree to receive SMS messages from {{ projectInfo.brandName }} Incentive Program and have read the <a :href="projectInfo.termsAndCondition" target="_blank"><span class="link">Terms And Condition</span></a> and <a :href="projectInfo.privacyPolicy" target="_blank"><span class="link">Privacy Policy</span></a>
          </div>
        </van-checkbox>
      </div> -->

      <!-- <div class="agreement-item">
        <van-checkbox v-model="formData.agreed2" shape="round" icon-size="16px" checked-color="#ee541b">
          <div class="agreement-text">
            I agree to receive a one-time verification code and Account Authorization Opening Notification
          </div>
        </van-checkbox>
      </div> -->
    </div>
    <!-- Number Keyboard -->
  </div>
</template>

<script>
import { Toast } from 'vant'
import { activityEmployeeSendCodeApi, activityEmployeeGetByPhoneApi } from '@/api'
export default {
  name: 'LoginCode',
  components: {
    XuCountryCode: () => import('@/components/XuCountryCode')
  },
  props: {
    isLoginCode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formData: {
        code: '',
        // agreed: false,
        // agreed2: false,
        phone: '',
        countryCode: '',
        authorizationCode: ''
      },
      countdown: 0,
      timer: null,
      formRules: [
        { label: 'SMS is Required', value: 'code' }
        // { label: 'Please agree to the terms', value: 'agreed' },
        // { label: 'Please agree to the terms', value: 'agreed2' }
      ],
      showKeyboard: false
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    handleGetCode () {
      if (this.countdown > 0) return
      const { phone, countryCode } = this.formData
      if (!this.activityInfo.employeeId && (!phone || !countryCode)) {
        Toast('Please enter complete Phone number')
        return
      }
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      const newPhone = !this.activityInfo.employeeId ? phone : this.activityInfo.phone
      const newCountryCode = !this.activityInfo.employeeId ? countryCode : this.activityInfo.countryCode
      activityEmployeeGetByPhoneApi(this.activityInfo.customerId, newPhone).then(result => {
        activityEmployeeSendCodeApi({ customerId: this.activityInfo.customerId, phone: newPhone, codeType: 'login', countryCode: newCountryCode }).then(res => {
          Toast.clear()
          this.formData.code = res.data
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-code {
  background-color: #fff;
  font-size: 12px;
  .tel-txt {
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0;
  }
  .anth-code {
    height: 32px;
    line-height: 32px;
    padding: 0px 10px;
    margin-bottom: 20px;
    border: 1px solid #dce5f6;
    border-radius: 5px;
  }
  .form-item {
    margin-bottom: 16px;
    .label {
      display: block;
      font-size: 13px;
      color: #333;
      margin-bottom: 5px;
      .required {
        color: #ee541b;
        margin-right: 4px;
      }
    }

    .input-wrapper {
      width: 100%;
    }

    .custom-field {
      width: 100%;
      height: 32px;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      padding: 0 12px; // Keep minimal horizontal padding
      // font-size: 16px; // Vant default is usually fine, adjust if needed
      box-sizing: border-box;
      // outline: none; // Not needed for Vant component
      color: #323233;
      display: flex;
      align-items: center;

      // Reset Vant field padding to match height centering
      /deep/ .van-field__control {
        height: 100%;
        line-height: normal; // Reset line-height to allow flex centering if needed
      }

      // Remove default padding from Vant field to rely on container padding or set specific
      &.van-cell {
        padding: 0 12px;
        line-height: 42px; // Center content vertically
      }

      &::placeholder {
        color: #c8c9cc;
      }

      &.select-field {
         // line-height: 42px; // handled by .van-cell above
         /deep/ .van-field__control:disabled {
            color: #323233; // Make readonly look like normal text
            -webkit-text-fill-color: #323233;
         }
        &.placeholder {
           /deep/ .van-field__control {
             color: #c8c9cc;
             -webkit-text-fill-color: #c8c9cc;
           }
        }
      }
    }
    .phone-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .phone-field {
        flex: 1;
        // text-align: center; // Vant uses text-align on input
        padding: 0 10px;
        border-radius: 4px; // Slight radius for focus effect
        transition: border-color 0.2s;
        border: 1px solid #dce5f6; // Default border color

        &.is-focused {
           border-color: #ee541b;
           background-color: #fff;
           box-shadow: 0 0 4px rgba(238, 84, 27, 0.2);
        }

        /deep/ .van-field__control {
          //  text-align: center;
        }
      }

      .country-code-field {
        width: 100px;
        margin-right: 10px;
      }

      .separator {
        margin: 0 8px;
        color: #999;
      }
    }
  }

  .sms-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .input-wrapper {
      flex: 1;
      margin-right: 15px;
    }

    .get-code-btn {
      color: #ee541b;
      font-size: 12px;
      white-space: nowrap;
      cursor: pointer;

      &.disabled {
        color: #999;
        cursor: not-allowed;
      }
    }
  }

  .agreement-item {
    margin-bottom: 16px;

    /deep/ .van-checkbox__label {
      line-height: 1.4;
    }

    .agreement-text {
      font-size: 12px;
      color: #333;
      padding-left: 10px;

      .link {
        color: #307bff;
        text-decoration: underline;
      }
    }
    /deep/.van-checkbox__icon .van-icon {
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }
}
</style>
